<template>
    <!-- <div class="crud-wrapper"> -->
        <crud-form :fullWidth="true" :fullScreen="true">
        <div class="register-container">
            <div class="image-box">
                <div class="header">
                    <img class="logo" :src="this.$config.imageUri(brandLogo, 'logo')" />
                    <div>
                        <p>Afiliados</p>
                        <h4>{{ brandName }}</h4>
                    </div>
                </div>
                <p class="text">Cadastre-se hoje para realizar a prospecção digital e o gerenciamento de leads com simplicidade.</p>
                <div class="row">
                    <a class="social" v-bind:key="social.id" v-for="social in socials" :href="social.link" target="_blank">
                        <i :style="{ color: '#'+social.color}" :class="'fab fa-' + social.icon"></i>
                    </a>
                    <!-- <a class="social" color="#f46f30" href="https://www.instagram.com/consigmaisoficial/" target="_blank">
                        <i class="fab fa-instagram"></i>
                    </a>
                    <a class="social" color="#3B5998" href="https://www.facebook.com/consigmaisoficial/" target="_blank">
                        <i class="fab fa-facebook-f"></i>
                    </a>
                    <a class="social" color="#a4c639" href="https://play.google.com/store/apps/details?id=br.com.consigmais&hl=pt_BR&gl=US" target="_blank">
                        <i class="fab fa-google-play"></i>
                    </a> -->
                    <!-- <a class="social" color="#a6b1b7">
                        <i class="fab fa-apple"></i>
                    </a> -->
                </div>
            </div>
            <div class="register-box">
                <h4>Cadastro de Afiliados</h4>
                <p class="description">Preencha todos os campos corretamente para realizar o envio do cadastro.</p>
                <a-text-field class="field" label="Nome" v-model="formData.name" validate="required"></a-text-field>
                <a-text-field class="field" label="Email" v-model="formData.mainEmail" validate="required,email"></a-text-field>

                <div class="row">
                    <a-text-field class="field" label="CPF/CNPJ" :disabled="loading" v-model="formData.federalId" validate="required,cpf_cnpj"></a-text-field>
                    <a-text-field class="field" label="CEP" mask="#####-###" v-model="formData.zipcode" validate="required"></a-text-field>
                </div>
                <div class="row">
                    <a-text-field class="field" label="Whatsapp" mask="(##) 9 ####-####" v-model="formData.phone" validate="required"></a-text-field>
                    <a-text-field class="field" disabled label="Código de indicação" v-model="formData.referrerCode"></a-text-field>
                </div>

                <button :disabled="loading" v-on:click="register()">
                    <v-progress-circular v-if="loading" color="yellow" indeterminate="indeterminate"></v-progress-circular>
                    <p v-else>Cadastrar</p>
                </button>
            </div>
        </div>
        <div v-if="brandLoading" class="fullscreen-loading">
            <v-progress-circular color="yellow" indeterminate="indeterminate"></v-progress-circular>
        </div>
        </crud-form>
    <!-- </div> -->
</template>
<script>
    import CrudFormClass from '@consigmais-team/vue-common/layout/crudPage/crudFormClass';
    
    export default CrudFormClass.extend({
        data() {
            return {
                loading: false,
                error: false,
                alreadyRegistered: false,
                errorMessage: "",
                errorNotification: false,
                emailSentNotification: false,
                
                url: "",
                brandLogo: '',
                brandName: '',
                brandLoading: false,

                socials: [],

                formData: {
                    name: "",
                    federalId: "",
                    mainEmail: "",
                    zipcode: "",
                    phone: "",
                    referrerCode: this.$route.query.referrerCode ? this.$route.query.referrerCode : "",
                },  
            }
        },

        created() {
            if (this.$route.query.referrerCode !== undefined)
            localStorage.setItem("referrerCode", this.$route.query.referrerCode);
            if (localStorage.getItem("referrerCode") !== undefined)
            this.formData.referrerCode = localStorage.getItem("referrerCode");

            this.getBrand();
            this.getSocials();
        },

        methods: {
            clearMask (data) { 
                return data.replace(/\.|,|-|\(|\)| /gi, "");
            },

            getSocials() {
                this.$api.dataService.getPublicData('getBrandSocial', {})
                .then((res) => {
                    this.socials = res;
                }).catch((err) => {
                    //
                });
            },

            async register() {
                this.loading = true;

                const data = {
                    ...this.formData,
                    phone: this.clearMask(this.formData.phone),
                    zipcode: this.clearMask(this.formData.zipcode),
                    federalId: this.formData.federalId,
                    mainEmail: this.formData.mainEmail.toLowerCase(),
                };

                await this.$api.authService.registerAffiliate(data)
                    .then((res) => {
                        this.formData = {
                            name: "",
                            federalId: "",
                            mainEmail: "",
                            zipcode: "",
                            phone: "",
                        };

                        this.$notifyUser({
                            type: 'success',
                            message: "Afiliado cadastrado!"
                        });
                    }).catch((err) => {
                        this.loading = false;
                        this.errorMessage = err.response.data.msg;
                        this.alreadyRegistered = err.response.data.msg.includes(
                            "já cadastrado"
                        );
                        this.$notifyUser({
                            type: 'error',
                            message: errorMessage
                        });
                    });

                this.loading = false;
            },

            async getBrand() {
                this.brandLoading = true;

                await this.$api.dataService.getPublicData('getBrandSimple', {})
                    .then((res) => {
                        document.title = res.brandName + " | Afiliados"
                        this.brandName = res.brandName;
                        this.brandLogo = res.brandLogo;
                    }).catch((err) => {
                        //
                    });

                this.brandLoading = false;
            }
        }
    });
</script>

<style scoped>
    h4 {
        color: #1D1AB5;
        margin-bottom: 5px;
        font-size: 32px;  
        font-weight: bold;
    }

    p {
        margin: 0;
    }

    .logo {
        margin-right: 15px;
    }

    .register-container {
        width: 100%;
        height: 100vh;
        display: flex;
        justify-content: center;
        flex-direction: row;
        overflow: hidden;
        background-color: #FFF;
        overflow: auto;
    }

    .register-box {
        width: 500px;
        padding: 50px;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .logo {
        width: 125px;
        margin-bottom: 5px;
        margin-left: -5px;
    }

    .title {
        color: #1D1AB5;
        margin-bottom: 5px;
        font-size: 32px;
    }

    .description {
        color: #555;
        margin-bottom: 25px;
    }

    .image-box {
        width: 500px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        padding: 50px;
    }

    .row {
        display: flex;
        flex-direction: row;
    }

    .field {
        flex: initial !important;
    }

    .row .field:first-child {
        margin-right: 5px;
    }

    .row .field:last-child {
        margin-left: 5px;
    }

    .label {
        margin-bottom: 5px;
    }

    .header {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        line-height: 1;
        margin-bottom: 15px;
    }

    .text {
        line-height: 1.5;
        font-size: 18px;
        margin-bottom: 25px;
    }

    .social {
        width: 40px;
        height: 40px;
        background-color: #FFF;
        box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.15);
        border-radius: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 5px;
        cursor: pointer;
        text-decoration: none;
    }

    button {
        width: 100%;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: none;
        padding: 15px;
        cursor: pointer;
        box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.15);
        border-radius: 5px;
        background-color: #1D1AB5;
        color: #EFEFEF;
        font-size: 16px;
        font-weight: bold;
        margin-top: 15px;
        transition: .2s;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    button:hover {
        background-color: #221fd7;
    }

    @media only screen and (max-width: 489px) {
        .register-container {
            justify-content: flex-start;
            flex-direction: column;
        }

        .register-box {
            width: 100%;
            height: auto;
            padding: 25px;
            justify-content: flex-start;
        }

        .image-box {
            padding: 25px;
            width: 100%;
        }
    }

    .fullscreen-loading {
        width: 100vw;
        height: 100vh;
        position: absolute;
        top: 0;
        left: 0;
        background-color: #EFEFEF;
        z-index: 2000;
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>


// WEBPACK FOOTER //
// src/pages/NewAffiliate.vue